module.exports = __webpack_public_path__ + "img/region-hdf.78e1a218.jpg";